import { render, staticRenderFns } from "./PotentialCustomerRouteList.vue?vue&type=template&id=7da63a36&scoped=true&"
import script from "./PotentialCustomerRouteList.vue?vue&type=script&lang=js&"
export * from "./PotentialCustomerRouteList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da63a36",
  null
  
)

export default component.exports